export default __webpack_public_path__ + "static/media/Zeus-2-5.d907f7ac.pdf";